import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import React, {useEffect, useState} from 'react';
import {Divider, Dropdown} from 'antd';
import {faCaretDown,
  //  faChartSimple
} from '@fortawesome/pro-solid-svg-icons';
import {faMagnifyingGlassChart} from '@fortawesome/pro-duotone-svg-icons';
import {faArrowUpRightFromSquare, faLink} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import {urlDomainRegex, urlSubDomainRegex, targetPageRegex} from '@/constants/regex';
import {useStore} from '@/store/root-store';
import {useRouter} from 'next/router';

interface Props {
  url: string;
  text?: string;
  countryCode?: string;
  isPublicPage?: boolean;
}

export const UrlDropdown:React.FC<Props> = observer(({url, countryCode='', text, isPublicPage=false}) => {
  const addProtocol = (!/^(https?:)?\/\//i.test(url)) ? 'https://' + url : url;
  const {settings: {customer: {setAuthModal}}} = useStore('');
  const [customerId, setCustomerId] = useState('');
  const router = useRouter();

  useEffect(() => {
    const {searchParams} = new URL(window.location.href);
    const customer = searchParams.getAll('customerId');
    if (customer.length > 0) {
      setCustomerId(customer[0]);
    }
  }, [router.asPath]);

  const checkMode = domainName => {
    let selectedMode = '';
    const value = domainName?.trim();
    const checkDomain = value?.match(urlDomainRegex);
    const checkSubDomain = value?.match(urlSubDomainRegex);
    const checkTargetPage = value?.match(targetPageRegex);
    if (checkDomain) {
      selectedMode = 'domain';
    } else if (checkSubDomain) {
      selectedMode = 'subdomain';
    } else if (checkTargetPage) {
      selectedMode = 'target_page';
    } else {
      selectedMode = 'domain';
    }
    return selectedMode;
  };
  const getDeropDownMenu = () => {
    return <DropdownWrapper>
      {/* <>
        <FlexWrapperDropDown style={{marginBottom: '-15px'}}>
          {isPublicPage ? <WrapperForPublic onClick={() => setAuthModal(true, false)}>
            <FontAwesomeIcon icon={faChartSimple} />
            <ButtonWrapper>Open in Competitor Researcher</ButtonWrapper>
          </WrapperForPublic> : <Link legacyBehavior href={`/research/competitor-researcher/new?domain=${addProtocol}&mode=${checkMode(addProtocol)}&country_code=${countryCode || ''}${customerId? `&customerId=${customerId}`: ''}`} passHref>
            <ButtonWrapperNewTab target='_blank' rel='noreferrer'>
              <div>
                <FontAwesomeIcon icon={faChartSimple} />
                <ButtonWrapper>Open in Competitor Researcher</ButtonWrapper>
              </div>
            </ButtonWrapperNewTab>
          </Link>}
        </FlexWrapperDropDown >
        <Divider style={{backgroundColor: '#E8E8E8'}} /> </> */}
      <FlexWrapperDropDown style={{marginBottom: '-15px', marginTop: '-10px'}}>
        {isPublicPage ? <WrapperForPublic onClick={() => setAuthModal(true, false)}>
          <FontAwesomeIcon icon={faLink} />
          <ButtonWrapper>Open in Backlink Researcher</ButtonWrapper>
        </WrapperForPublic> : <Link legacyBehavior href= {`/research/backlink-researcher/new?domain=${addProtocol}&mode=${checkMode(addProtocol)}&country_code=${countryCode || ''}${customerId? `&customerId=${customerId}`: ''}`} passHref>
          <ButtonWrapperNewTab target='_blank' rel='noreferrer'>
            <div>
              <FontAwesomeIcon icon={faLink} />
              <ButtonWrapper>Open in Backlink Researcher</ButtonWrapper>
            </div>
          </ButtonWrapperNewTab>
        </Link>}
      </FlexWrapperDropDown>
      <Divider style={{backgroundColor: '#E8E8E8'}} />
      <FlexWrapperDropDown style={{marginBottom: '-15px', marginTop: '-10px'}}>
        {isPublicPage ? <WrapperForPublic onClick={() => setAuthModal(true, false)}>
          <FontAwesomeIcon icon={faMagnifyingGlassChart} />
          <ButtonWrapper>Open in Site Explorer</ButtonWrapper>
        </WrapperForPublic> : <Link legacyBehavior href= {`/site-explorer/detail/new?url=${addProtocol}&mode=${checkMode(addProtocol)}&country_code=${countryCode || ''}`} passHref>
          <ButtonWrapperNewTab target='_blank' rel='noreferrer'>
            <div>
              <FontAwesomeIcon icon={faMagnifyingGlassChart} />
              <ButtonWrapper>Open in Site Explorer</ButtonWrapper>
            </div>
          </ButtonWrapperNewTab>
        </Link>}
      </FlexWrapperDropDown>
      <Divider style={{backgroundColor: '#E8E8E8'}} />
      <FlexWrapperDropDown style={{marginTop: '-7px'}}>
        <Link legacyBehavior href={`${addProtocol}`} passHref>
          <ButtonWrapperNewTab target='_blank' rel='noopener noreferrer'>
            <div>
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              <ButtonWrapper>Open page on website</ButtonWrapper>
            </div>
          </ButtonWrapperNewTab>
        </Link>
      </FlexWrapperDropDown>
    </DropdownWrapper>
    ;
  };

  return (
    <Dropdown overlayStyle={{minWidth: '200px', border: '1px solid #E8E8E8', borderRadius: '8px', background: '#fff'}} overlay={() => getDeropDownMenu()} trigger={['click']} placement='bottomLeft'>
      <SerpName>{text ? text : url}<span>&nbsp;
        <FontAwesomeIcon icon={faCaretDown}/>
      </span></SerpName></Dropdown>
  );
});

const SerpName = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #2D6CCA;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover{
    text-decoration: underline;
  }
`;

const ButtonWrapper = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #121212;
`;
const DropdownWrapper = styled.div`
  padding: 18px 20px 8px 15px;
`;

const WrapperForPublic = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;
const ButtonWrapperNewTab = styled.a`
   color: #121212;
  text-decoration: none;
  > div {
    display: flex;
    gap: 12px;
    align-items: center;
  }
`;
const FlexWrapperDropDown = styled.div`
  display: flex;
  cursor: pointer;

`;
